import React from 'react';

import { PaddingType, PageWrapperProps } from './page-wrapper.entity';
import './page-wrapper.less';

export function PageWrapper(props: PageWrapperProps) {
  const { children, padding = ['left', 'right', 'top', 'bottom'] } = props;

  function makePadding(paddingType: PaddingType[]) {
    return paddingType.map(item => `padding-${item}`).join(' ');
  }

  return (
    <div className={`content-page-wrapper  ${makePadding(padding)}`}>
      {children}
    </div>
  );
}
